import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { resetCookieConsent } from '../components/CookieBanner';

export const Cookies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="cookies-page" style={{ backgroundColor: '#0A0A0A', color: '#E6E6E6', minHeight: '100vh' }}>
      <section style={{ position: 'relative', padding: '160px 24px 80px' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <p style={{ fontSize: '11px', color: 'rgba(194,168,120,0.6)', letterSpacing: '4px', textTransform: 'uppercase', fontWeight: 300, marginBottom: '18px' }}>
            Privacy & Compliance
          </p>
          <h1 className="font-serif" style={{ fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: 500, color: '#FAFAFA', letterSpacing: '-0.3px', lineHeight: 1.1, marginBottom: '20px' }}>
            Cookie Policy
          </h1>
          <p style={{ fontSize: '13px', color: 'rgba(225,225,225,0.8)', fontWeight: 300 }}>
            Last updated: May 13, 2026
          </p>

          <div style={{ marginTop: '60px' }}>
            <Section title="What Cookies Are">
              Cookies are small text files stored on your device when you visit a website. They help the site remember preferences,
              improve performance, and understand how visitors use it. We use only a minimal set.
            </Section>

            <Section title="Cookies We Use">
              <CookieRow
                name="Essential cookies"
                purpose="Required for the site to function — navigation, security, your booking form session."
                duration="Session"
                consent="Always on (functional necessity)"
              />
              <CookieRow
                name="Google Analytics (_ga, _gid)"
                purpose="Helps us understand which pages and services visitors find useful so we can improve them."
                duration="Up to 2 years"
                consent="Only with your consent"
              />
            </Section>

            <Section title="Your Choices">
              The first time you visit Toronto Royale, you'll see a banner at the bottom of the page. You can:
              <ul style={{ marginTop: '14px', paddingLeft: '20px', listStyle: 'none' }}>
                <li style={{ marginBottom: '10px' }}>
                  <span style={{ color: '#C2A878', marginRight: '8px' }}>•</span>
                  <strong style={{ color: '#FAFAFA', fontWeight: 500 }}>Accept</strong> — we load Google Analytics and remember your choice for 12 months.
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <span style={{ color: '#C2A878', marginRight: '8px' }}>•</span>
                  <strong style={{ color: '#FAFAFA', fontWeight: 500 }}>Decline</strong> — Google Analytics never loads. We remember your choice for 6 months.
                </li>
              </ul>
              You can change your mind at any time using the button below.
            </Section>

            <div style={{ marginTop: '40px', marginBottom: '50px', textAlign: 'center' }}>
              <button
                data-testid="cookies-reset-btn"
                onClick={resetCookieConsent}
                style={{
                  padding: '13px 32px',
                  fontSize: '11px',
                  fontWeight: 600,
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  background: 'transparent',
                  color: '#C2A878',
                  border: '1px solid rgba(194,168,120,0.4)',
                  cursor: 'pointer',
                  transition: 'all 200ms ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(194,168,120,0.08)';
                  e.currentTarget.style.borderColor = 'rgba(194,168,120,0.7)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = 'rgba(194,168,120,0.4)';
                }}
              >
                Change My Cookie Choice
              </button>
            </div>

            <Section title="Third-Party Cookies">
              We do not use advertising trackers, retargeting pixels, social media trackers, or affiliate cookies.
              The only third-party cookie we use — and only with your consent — is Google Analytics.
            </Section>

            <Section title="Legal Basis">
              For visitors in Canada, this policy is governed by the Personal Information Protection and Electronic Documents
              Act (PIPEDA) and, for Quebec residents, the Act respecting the protection of personal information in the private
              sector (Law 25). For visitors in the European Economic Area, we apply GDPR consent rules.
            </Section>

            <Section title="Contact">
              Questions about this policy? Reach us at <a href="mailto:bookings@torontoroyale.com" style={{ color: '#C2A878', textDecoration: 'none', borderBottom: '1px solid rgba(194,168,120,0.4)' }}>bookings@torontoroyale.com</a>.
            </Section>

            <div style={{ marginTop: '60px', paddingTop: '32px', borderTop: '1px solid rgba(194,168,120,0.1)', textAlign: 'center' }}>
              <Link to="/privacy" style={{ color: 'rgba(194,168,120,0.7)', fontSize: '12px', textDecoration: 'none', marginRight: '24px', letterSpacing: '0.5px' }}>
                Privacy Policy &rarr;
              </Link>
              <Link to="/terms" style={{ color: 'rgba(194,168,120,0.7)', fontSize: '12px', textDecoration: 'none', letterSpacing: '0.5px' }}>
                Terms & Conditions &rarr;
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '40px' }}>
    <h2 className="font-serif" style={{ fontSize: '22px', fontWeight: 500, color: '#FAFAFA', marginBottom: '14px' }}>
      {title}
    </h2>
    <div style={{ fontSize: '15px', color: 'rgba(204,204,204,0.7)', lineHeight: 1.85, fontWeight: 300 }}>
      {children}
    </div>
  </div>
);

const CookieRow = ({ name, purpose, duration, consent }) => (
  <div style={{ marginTop: '20px', padding: '20px 22px', backgroundColor: 'rgba(14,14,14,0.5)', border: '1px solid rgba(194,168,120,0.08)' }}>
    <p style={{ fontSize: '14px', color: '#FAFAFA', fontWeight: 500, marginBottom: '12px' }}>{name}</p>
    <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '6px 18px', fontSize: '13px', color: 'rgba(204,204,204,0.65)', lineHeight: 1.6 }}>
      <span style={{ color: 'rgba(194,168,120,0.6)', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', alignSelf: 'center' }}>Purpose</span>
      <span>{purpose}</span>
      <span style={{ color: 'rgba(194,168,120,0.6)', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', alignSelf: 'center' }}>Duration</span>
      <span>{duration}</span>
      <span style={{ color: 'rgba(194,168,120,0.6)', fontSize: '10px', letterSpacing: '1.5px', textTransform: 'uppercase', alignSelf: 'center' }}>Consent</span>
      <span>{consent}</span>
    </div>
  </div>
);
